// Explore-stats page: Length of service groups and distribution — current.
// Recreates the Handbook page — histogram of current parliamentarians by
// length-of-service band, with a band/number/% table.

import React, { useState, useEffect } from 'react';
import { Paper, Typography } from '@mui/material';
import { getExploreStat } from '../../services/api';
import ExploreStatsPage from './ExploreStatsPage';
import { StatHistogram } from './charts';

export default function LengthOfServiceGroups() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await getExploreStat('length-of-service-groups');
        if (active) setData(res);
      } catch (e) {
        if (active) setError(e.message || 'Failed to load statistics');
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  const charts = data?.charts || {};

  return (
    <ExploreStatsPage
      title="Length of service groups and distribution — current Parliament"
      description={`How long current parliamentarians have served${
        charts.total ? ` (${charts.total} parliamentarians)` : ''
      } — a high number of newer parliamentarians and a decreasing number who have served longer periods.`}
      loading={loading}
      error={error}
      columns={data?.columns || []}
      rows={data?.table_rows || []}
      links={data?._links || []}
      csvName="length-of-service-groups"
    >
      {data && (
        <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>
            Length of service groups and distribution — current Parliament
          </Typography>
          <StatHistogram data={charts.length_of_service || []}
                         xKey="band" yKey="count" />
        </Paper>
      )}
    </ExploreStatsPage>
  );
}
